<footer class="embed-footer-component">
  <div [innerHTML]="resources.InsightsWidgetPoweredBy"></div>
</footer>
